import { render, staticRenderFns } from "./travelSummary.vue?vue&type=template&id=0a047fc6&"
import script from "./travelSummary.vue?vue&type=script&lang=ts&"
export * from "./travelSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports